<template>
  <div class="advertisement">
    <div
      v-for="(item, index) in advertLists"
      :key="item.id"
    >
      <img
        :src="item.images"
        alt=""
        @click="advertCenter(index)"
      />
    </div>
  </div>
</template>

<script>
import { setBaseUrl, gioPlatform, gioJumpType,handleJumpType } from '@/utils/tools';

const pageYear = (window.location.pathname.indexOf('ark/home') !== -1) ? 24 : 23;

export default {
  props: {
    advertLists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lastTime: null,
      gioType: 1, // 用于埋点 1 点击 2曝光
    };
  },
  watch: {
    advertLists() {
      this.gioEvent(this.advertLists, (this.gioType = 2));
    },
  },
  methods: {
    advertCenter(index) {
      if (this.lastTime) {
        if (Date.now() - this.lastTime < 1000) return;
      }
      this.gioEvent(this.advertLists[index], (this.gioType = 1));
      this.lastTime = Date.now();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      handleJumpType(this, this.advertLists[index]);
    },
    gioEvent(item, type) {
      const { title, skipType } = item;
      if (type === 1) {
        const adId = item.id;
        // 点击广告
        // eslint-disable-next-line
        gio('evar.set', 'capsuleFigure_evar', title);
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: `${pageYear}考研-首页-胶囊区`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        const sortList = []; const adIdList = []; const adNameList = []; const jumpTypeList = [];
        if (!item) {
          return;
        }
        item.forEach((element) => {
          sortList.push(element.sort);
          adIdList.push(element.id);
          adNameList.push(element.title);
          // eslint-disable-next-line
          const jumpType = gioJumpType(element.skipType)
          // element.skipType === 1 ? '链接' : element.skipType === 2 ? '产品' : element.skipType === 3 ? '自定义产品列表' : element.skipType === 4 ? '产品分类列表' : element.skipType === 5 ? '套餐' : '其他';
          jumpTypeList.push(jumpType);
        });
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: `${pageYear}考研-首页-胶囊区`, // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adIdList.toString(), // 广告ID
          adName_var: adNameList.toString(), // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: jumpTypeList.toString(), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.advertisement {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0 5px 0;
  padding: 0 40px 40px 40px;

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 326px;
    height: 120px;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
      margin-bottom: 25px;
      border-radius: 8px;
    }
  }

  // 老的标签样式
  // .content{
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   width: 326px;
  //   height: 118px;
  //   padding: 30px 30px 30px 26px;
  //   background: #FFF3EA;
  //   border-radius: 12px;

  //    .text {
  //     display: flex;
  //     flex-direction: column;

  //     span:first-child {
  //       height: 30px;
  //       margin-bottom: 10px;
  //       color: #333333;
  //       font-weight: 500;
  //       font-size: 25px;
  //       line-height: 30px;
  //     }
  //     span{
  //       height: 30px;
  //       color: #FFA25F;
  //       font-weight: 500;
  //       font-size: 22px;
  //       line-height: 30px;
  //       img {
  //         width: 18px;
  //         height: 18px;
  //       }
  //     }
  //   }

  //   img {
  //     width: 49px;
  //     height: 49px;
  //   }

  // }
}
// .advertisement {
//   width: 750px;
//   margin: 0 auto;
//   // padding: 0.2px 0;
//   background: #fff;
// }
// .advertisement div {
//   width: 100%;
//   height: 150px;
// }
// .advertisement div img {
//   width: 100%;
//   height: 150px;
// }
</style>
